import React, { useEffect, useState, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Axios from "axios";
import { useNavigate } from "react-router";
import {
  FaRegThumbsUp,
  FaThumbsUp,
  FaRegThumbsDown,
  FaThumbsDown,
} from "react-icons/fa";
import { MdOutlineCategory, MdTimer } from "react-icons/md";
import { GrShareOption } from "react-icons/gr";
import {
  filterPosts,
  getCategoriesByType,
  listPosts,
  profileUser,
} from "../api/service";
import { AiFillPlusCircle } from "react-icons/ai";
import toast, { Toaster } from "react-hot-toast";
import { RWebShare } from "react-web-share";
import Popover from "../components/Popover";
import useSearchParamsCustom from "../hooks/useSearchParamsCustom";
import PostCard from "../components/PostCard";
import '../styles/featureCard.css';
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cube";
import "swiper/css/pagination";

// import required modules
import { EffectCube, Pagination, Mousewheel } from "swiper/modules";

function notifysuccess() {
  toast.success("Liked");
}

function notifyerror() {
  toast.error("Disliked");
}

const Featured = () => {
  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        console.log(req.data);
      } else {
        navigate("/");
      }
    });
  };

  const [posts, setPosts] = useState([]);
  const [timeDifference, setTimeDifference] = useState({});
  const { setSearchParamsCustom, getSearchParam, deleteSearchParam } = useSearchParamsCustom();
  

  useEffect(() => {
    const calculateTimeDifference = () => {
      const currentTime = new Date();
      const timeDifferences = {};

      posts.forEach((post) => {
        const postTime = new Date(post.createdAt);
        const timeDiff = currentTime - postTime;
        const minutes = Math.floor(timeDiff / (1000 * 60));
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);

        if (weeks > 0) {
          timeDifferences[post._id] = `${weeks} week${weeks > 1 ? "s" : ""} ago`;
        } else if (days > 0) {
          timeDifferences[post._id] = `${days} day${days > 1 ? "s" : ""} ago`;
        } else if (hours > 0) {
          timeDifferences[post._id] = `${hours} hour${hours > 1 ? "s" : ""} ago`;
        } else if (minutes > 1) {
          timeDifferences[post._id] = `${minutes} minutes ago`;
        } else {
          timeDifferences[post._id] = "just now";
        }
      });
      setTimeDifference(timeDifferences);
    };

    calculateTimeDifference();
    const interval = setInterval(calculateTimeDifference, 60000);
    return () => clearInterval(interval);
  }, [posts]);

  const handleLike = async (postId) => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/posts/${postId}/like`,
        null,
        {
          headers: {
            authorization: token,
          },
        }
      );

      const updatedPosts = posts.map((post) => {
        if (post._id === postId) {
          return { ...post, likes: response.data.likes };
        }
        return post;
      });

      setPosts(updatedPosts);
      notifysuccess();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDislike = async (postId) => {
    try {
      const response = await Axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/posts/${postId}/dislike`,
        null,
        {
          headers: {
            authorization: token,
          },
        }
      );

      const updatedPosts = posts.map((post) => {
        if (post._id === postId) {
          return { ...post, dislikes: response.data.dislikes };
        }
        return post;
      });

      setPosts(updatedPosts);
      notifyerror();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    profileInit();
    listPosts(token)
      .then((res) => {
        setPosts(res.data);
      })
      .catch((err) => console.log(err));
  }, [token]);

  
  return (
    <>
 <Swiper
        direction="vertical"
        effect={"cube"}
        cubeEffect={{
          shadow: false,
          slideShadows: false,
          shadowOffset: 20,
          shadowScale: 0.94,
        }}
        grabCursor={true}
        mousewheel={true}
        modules={[Mousewheel, EffectCube]}
        className="swiper mySwiper"
      >
    {posts.map((post, index) => (
      <SwiperSlide key={index} className="w-full h-screen overflow-hidden ">
        <div className="w-full h-full shadow-none">
          <PostCard
            post={post}
            onLike={handleLike}
            onDislike={handleDislike}
            likesCount={post.likes.length}
            dislikesCount={post.dislikes.length}
            timeDifference={timeDifference}
            postimg={`${post.image}`}
            category={post.category}
            name={post.author}
          />
        </div>
      </SwiperSlide>
    ))}
  </Swiper>
  <Navbar />
    </>
  );
  
};

export default Featured;
